import HyperDX from "@hyperdx/browser";
import env from "./env.mjs";

if (process.env.NODE_ENV === "production") {
  try {
    HyperDX.init({
      apiKey: env.NEXT_PUBLIC_HYPERDX_KEY,
      service: "blaest-browser",
      consoleCapture: true,
      advancedNetworkCapture: false,
      instrumentations: {
        connectivity: false,
        document: false,
        longtask: false,
        visibility: false,
        websocket: false,
        interactions: false,
        postload: false,
        socketio: false,
      },
      disableReplay: true,
    });
  } catch (error) {
    console.warn("Failed to initialize HyperDX:", error);
  }
}
